import {
  FETCH_NOTIFICATIONS_REQUEST,
  FETCHING_NOTIFICATIONS_SUCCEDDED,
  FETCHING_NOTIFICATIONS_FAILED,
  DELETE_ALL_NOTIFICATIONS_REQUEST,
  DELETE_ALL_NOTIFICATIONS_SUCCEEDED,
  DELETE_ALL_NOTIFICATIONS_FAILED,
  MARK_NOTIFICATIONS_AS_READ_SUCCEEDED,
  FETCHING_NOTIFICATIONS_COUNT_SUCCEDDED
} from "../actions/actionTypes";
import {FetchNotificationResponse, FetchNotificationErrorResponse, Notification} from "src/types/hub"
import { uniqBy } from "lodash";
import { type UnknownAction } from '@reduxjs/toolkit';



interface NotificationState {
  loading: boolean;
  deleting : boolean;
  records: Notification[];
  error: any;
  pagination: {
    currentPage: number;
    totalPages: number;
    recordsPerPage: number;
    totalRecordsCount: number;
    hasMoreItems: boolean;
  };
  notificationsCount: number
}

const initialState: NotificationState = {
  loading: false,
  deleting: false,  
  records: [],
  pagination: {
    currentPage: -1,
    totalPages: 0,
    recordsPerPage: 10,
    totalRecordsCount: 0,
    hasMoreItems: false,
  },
  error: null,
  notificationsCount: 0
};


export function notificationReducer(state = initialState, action: UnknownAction) {
  switch (action.type) {
    case FETCH_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCHING_NOTIFICATIONS_SUCCEDDED:
      const response = action.payload as FetchNotificationResponse;
      let records: Notification[] = []; 

      if (response.currentPage === 0) {
        records = response.records;
      } else {
        records = [...state.records, ...response.records];
      }
      
        records = uniqBy(records, (n: Notification) => {
          return `${n.id}_${n.createdDate}`; 
        });

        return {
          ...state,
          loading: false,
          records: records,  
          pagination: {
            ...state.pagination,
            currentPage: response.currentPage,
            totalPages: response.totalPages,
            hasMoreItems: response.currentPage < response.totalPages - 1 
          },
        };
      
    case FETCHING_NOTIFICATIONS_FAILED:
      const NotificationFailedPayload = action.payload as FetchNotificationErrorResponse;
      return {
        ...state,
        loading: false,
        error: NotificationFailedPayload.error,
      };

      case FETCHING_NOTIFICATIONS_COUNT_SUCCEDDED: {
        return  {
          ...state,
          notificationsCount: action.payload as number
        };
      }

      case MARK_NOTIFICATIONS_AS_READ_SUCCEEDED:
        var count = action.payload;
  
        return Object.assign({}, state, {
          ...state,
          notificationsCount: count
        });

    case DELETE_ALL_NOTIFICATIONS_REQUEST:

          return Object.assign({}, state, {
        ...state,
            deleting: true
          })

    case DELETE_ALL_NOTIFICATIONS_SUCCEEDED:
          return Object.assign({}, state, {
        ...state,
        deleting: false,
            records: []
          });

    case DELETE_ALL_NOTIFICATIONS_FAILED:
          const DeleteNotificationFailedPayload = action.payload as FetchNotificationErrorResponse;

          return Object.assign({}, state, {
        ...state,
        deleting: false,
            error: DeleteNotificationFailedPayload.error
          });

    default:
      return state;
  }
}
